import axios from 'axios';
import AsyncLocalStorage from '@createnextapp/async-local-storage';

const showToast = (message, type = 'error') => {
  let toastContainer = document.getElementById('global-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'global-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
    `;
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.style.cssText = `
    background: ${type === 'error' ? '#f44336' : '#4caf50'};
    color: white;
    padding: 16px 24px;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    animation: slideIn 0.3s ease-out;
    min-width: 300px;
  `;
  toast.textContent = message;

  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
  if (!document.getElementById('toast-animation-style')) {
    style.id = 'toast-animation-style';
    document.head.appendChild(style);
  }

  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = 'slideIn 0.3s ease-out reverse';
    setTimeout(() => {
      toast.remove();
    }, 300);
  }, 3000);
};

const METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};

let isRedirecting = false;

// const BASEURL = "http://192.168.1.131/fitt_lab_studio_admin/api/";
const BASEURL = "https://administrator.fittlabstudio.com/api/";

class Api {
  isLoggedIn = false;

  constructor() {
    this.baseURL = BASEURL;
    this.isAlreadyFetchingAccessToken = true;
  }

  get(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.GET, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  post(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.POST, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  put(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PUT, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  patch(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PATCH, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  delete(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.DELETE, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  api(method, url, data) {
    return AsyncLocalStorage.getItem('authToken').then(token => {
      if (token && token !== '') {
        this.isLoggedIn = true;
        this.accessToken = token;
      }
      return new Promise((resolve, reject) => {
        let axiosConfig = {};
        axiosConfig.method = method;

        axiosConfig.url = this.baseURL + url;

        axiosConfig.headers = this.setHeaders(data);

        if (data && data.responseType === 'blob') {
          axiosConfig.responseType = 'blob';
        }

        if (data) {
          if (data.params) axiosConfig.params = data.params;

          if (data.data) axiosConfig.data = data.data;
        }

        axios(axiosConfig)
          .then(response => {
            if (axiosConfig.responseType === 'blob') {
              resolve(response.data);
            } else {
              resolve(response.data);
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              if (!isRedirecting) {
                isRedirecting = true;

                showToast('Your session has expired. Please login again.', 'error');

                localStorage.clear();
                AsyncLocalStorage.clear();

                setTimeout(() => {
                  isRedirecting = false;
                  window.location.href = '/auth/login';
                }, 2000);
              }

              reject({ success: false, message: 'Session expired' });
              return;
            }

            if (error.response) {
              reject(error.response.data);
            } else {
              reject(error);
            }
          });
      });
    });
  }

  setHeaders(data) {
    let headers = {};
    headers['accept-language'] = 'en';
    headers['Content-Type'] = 'application/json';
    headers['Xapi'] = 'jwZryAdcrffggf867DnjhjhfRvsfhjs08032022';

    if (data) {
      if (data.isMultipart) {
        headers['Content-Type'] = 'multipart/form-data';
      }

      if (data.headers) {
        for (var key in data.headers) {
          if (data.headers.hasOwnProperty(key)) {
            headers[key] = data.headers[key];
          }
        }
      }
    }

    if (this.isLoggedIn !== false && !(data && data.skipAuth)) {
      headers['Authorization'] = 'Bearer ' + this.accessToken;
    }

    return headers;
  }
}

export default Api;
